<template>
  <v-snackbar
    v-model="show"
    :color="color"
    :multi-line="multiline"
  >
    {{ message }}
  </v-snackbar>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      multiline: false,
      message: '',
      color: ''
    }
  },

  created () {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'snackbar/showMessage') {
        this.message = state.snackbar.content
        this.color = state.snackbar.color
        this.multiline = state.snackbar.multiline
        this.show = true
      }
    })
  }
}
</script>
